export const formatPhone = (value: string) => {
  const digits = value.replace(/\D/g, "");

  let normalized = digits.startsWith("8") ? "7" + digits.slice(1) : digits;

  if (!normalized.startsWith("7")) {
    normalized = "7" + normalized;
  }
  if (normalized.length > 11) {
    normalized = normalized.slice(0, 11);
  }

  if (normalized.length === 1) {
    return `+${normalized}`;
  } else if (normalized.length <= 4) {
    return `+${normalized.slice(0, 1)} (${normalized.slice(1)}`;
  } else if (normalized.length <= 7) {
    return `+${normalized.slice(0, 1)} (${normalized.slice(
      1,
      4
    )}) ${normalized.slice(4)}`;
  } else if (normalized.length <= 9) {
    return `+${normalized.slice(0, 1)} (${normalized.slice(
      1,
      4
    )}) ${normalized.slice(4, 7)}-${normalized.slice(7)}`;
  } else {
    return `+${normalized.slice(0, 1)} (${normalized.slice(
      1,
      4
    )}) ${normalized.slice(4, 7)}-${normalized.slice(7, 9)}-${normalized.slice(
      9
    )}`;
  }
};

export const formatPrice = (price: number) => {
  return new Intl.NumberFormat("ru-RU").format(price) + " ₽";
};

export const formatPhotoUrl = (path?: string) => {
  let url = "/icons/no-image.svg";

  if (path) {
    url = "https://dominat.pro/poscloud/images/goods/gener/084/" + path;
  }

  return url;
};
